import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

import { APISD } from "../../../../../../../../config/apisd";
import ToastError from "../../../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../../../NotificationToast/ToastSuccess";

import "bulma/css/bulma.css";
import "../../../../../../../../index.css";

const modalStyles = `
  .pj-form-section {
    grid-column: 1 / -1;
    padding-top: 2px;
  }

  .pj-form-section-title {
    margin: 0 0 10px;
    color: #17213d;
    font-size: 13px;
    font-weight: 700;
  }

  .pj-day-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 9px;
  }

  .pj-day-option {
    display: flex;
    min-height: 42px;
    align-items: center;
    gap: 9px;
    padding: 9px 11px;
    border: 1px solid #e0e6f1;
    border-radius: 10px;
    background: #ffffff;
    color: #46526d;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: border-color 0.2s ease, background 0.2s ease;
  }

  .pj-day-option:hover {
    border-color: #b9c9ed;
    background: #f9fbff;
  }

  .pj-day-option.is-checked {
    border-color: #8aa5f5;
    background: #f1f5ff;
    color: #315fc5;
  }

  .pj-day-option input {
    width: 16px;
    height: 16px;
    margin: 0;
    accent-color: #3f5bea;
  }

  @media (max-width: 640px) {
    .pj-day-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
`;

const initialForm = {
  in_time: "",
  out_time: "",
  grace_period_in: "",
  grace_period_out: "",
  note: "",
  notification: false,
  days: {
    senin: true,
    selasa: false,
    rabu: false,
    kamis: false,
    jumat: false,
    sabtu: false,
    minggu: false,
  },
};

const dayOptions = [
  ["senin", "Senin"],
  ["selasa", "Selasa"],
  ["rabu", "Rabu"],
  ["kamis", "Kamis"],
  ["jumat", "Jumat"],
  ["sabtu", "Sabtu"],
  ["minggu", "Minggu"],
];

export default function ModalAturWaktuAdd(props) {
  const token = localStorage.getItem("token");
  const idUser = localStorage
    .getItem("id_admin")
    ?.replace(/[|&;$%@"<>()+,]/g, "");

  const [form, setForm] = useState(initialForm);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleDayChange = (key) => {
    setForm((prev) => ({
      ...prev,
      days: {
        ...prev.days,
        [key]: !prev.days[key],
      },
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!props?.filterData?.ysb_semester_id) {
      ToastError.fire({ icon: "error", title: "Semester belum dipilih" });
      return;
    }

    if (!props?.filterData?.ysb_branch_id) {
      ToastError.fire({ icon: "error", title: "Cabang belum dipilih" });
      return;
    }

    if (!props?.filterData?.ysb_school_id) {
      ToastError.fire({ icon: "error", title: "Sekolah belum dipilih" });
      return;
    }

    if (!form.in_time) {
      ToastError.fire({ icon: "error", title: "Jam masuk wajib diisi" });
      return;
    }

    if (!form.out_time) {
      ToastError.fire({ icon: "error", title: "Jam keluar wajib diisi" });
      return;
    }

    setIsSubmitting(true);

    const payload = {
      ysb_semester_id: props.filterData.ysb_semester_id,
      ysb_branch_id: props.filterData.ysb_branch_id,
      ysb_school_id: props.filterData.ysb_school_id,
      in_time: form.in_time,
      out_time: form.out_time,
      grace_period_in: form.grace_period_in || "0",
      grace_period_out: form.grace_period_out || "",
      day_1: !!form.days.senin,
      day_2: !!form.days.selasa,
      day_3: !!form.days.rabu,
      day_4: !!form.days.kamis,
      day_5: !!form.days.jumat,
      day_6: !!form.days.sabtu,
      day_7: !!form.days.minggu,
      notification: !!form.notification,
      note: form.note || "",
      user_id: idUser,
    };

    try {
      const response = await APISD.post(
        "/api/absen-config/store",
        payload,
        fetchParams
      );

      if (response?.status === 200) {
        ToastSuccess.fire({
          icon: "success",
          title: response?.data?.message || "Berhasil menyimpan data",
        });

        await props.GetResponseData();
        props.onHide();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal menyimpan data",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="module-modal-dialog"
      contentClassName="module-modal-content"
    >
      <style>{modalStyles}</style>

      <form onSubmit={handleSubmit}>
        <div className="module-modal-header">
          <div>
            <h5 className="module-modal-title">Tambah Pengaturan Jam</h5>
            
          </div>

          <button
            type="button"
            className="module-modal-close"
            onClick={props.onHide}
            disabled={isSubmitting}
            aria-label="Tutup modal"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <Modal.Body className="module-modal-body mt-1 mx-2">
          <div className="module-form-grid">
            <div className="module-form-group">
              <label className="module-form-label" htmlFor="in_time">
                Jam Masuk <span>*</span>
              </label>
              <input
                id="in_time"
                name="in_time"
                type="time"
                className="module-form-input"
                value={form.in_time}
                onChange={handleChange}
                required
              />
            </div>

            <div className="module-form-group">
              <label className="module-form-label" htmlFor="out_time">
                Jam Pulang <span>*</span>
              </label>
              <input
                id="out_time"
                name="out_time"
                type="time"
                className="module-form-input"
                value={form.out_time}
                onChange={handleChange}
                required
              />
            </div>

            <div className="module-form-group">
              <label className="module-form-label" htmlFor="grace_period_in">
                Batas Telat Masuk
              </label>
              <input
                id="grace_period_in"
                name="grace_period_in"
                type="number"
                min="0"
                className="module-form-input"
                value={form.grace_period_in}
                onChange={handleChange}
                placeholder="(hitungan menit)"
              />
            </div>

            <div className="module-form-group">
              <label className="module-form-label" htmlFor="note">
                Catatan
              </label>
              <input
                id="note"
                name="note"
                type="text"
                className="module-form-input"
                value={form.note}
                onChange={handleChange}
                
              />
            </div>

            <div className="pj-form-section">
              <p className="pj-form-section-title">Hari Berlaku</p>
              <div className="pj-day-grid">
                {dayOptions.map(([key, label]) => (
                  <label
                    className={`pj-day-option ${
                      form.days[key] ? "is-checked" : ""
                    }`}
                    htmlFor={`day-${key}`}
                    key={key}
                  >
                    <input
                      id={`day-${key}`}
                      type="checkbox"
                      checked={form.days[key]}
                      onChange={() => handleDayChange(key)}
                    />
                    {label}
                  </label>
                ))}
              </div>
            </div>

            <div className="module-form-span-2">
              <div className="module-status-form-card">
                <div className="module-status-form-info">
                  <span className="module-status-form-title">
                    Notifikasi Alpa
                  </span>
                  <span className="module-status-form-description">
                    Aktifkan notifikasi ketika siswa tercatat tidak hadir.
                  </span>
                </div>

                <label className="module-toggle" htmlFor="notification">
                  <input
                    id="notification"
                    type="checkbox"
                    checked={form.notification}
                    onChange={() =>
                      setForm((prev) => ({
                        ...prev,
                        notification: !prev.notification,
                      }))
                    }
                  />
                  <span className="module-toggle-slider" />
                </label>
              </div>
            </div>
          </div>
        </Modal.Body>

        <div className="module-modal-footer">
          <button
            type="button"
            className="module-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="module-modal-submit"
            disabled={isSubmitting}
          >
            {isSubmitting && <span className="module-button-spinner" />}
            {isSubmitting ? "Menyimpan..." : "Simpan"}
          </button>
        </div>
      </form>
    </Modal>
  );
}
